import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getAirlines, addAirline, updateAirline } from "../api/airlineApi";
import { showError } from "../utils/alert";

const initialForm = {
  name: "",
  iata_code: "",
  country: "",
  alliance: "",
};

export default function AirlineForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      loadAirline();
    }
  }, [id]);

  const loadAirline = async () => {
    try {
      const res = await getAirlines({ page: 1, per_page: 1000 });
      const airline = res.data.items.find((a) => a.id === parseInt(id));
      if (airline) {
        setForm({
          name: airline.name || "",
          iata_code: airline.iata_code || "",
          country: airline.country || "",
          alliance: airline.alliance || "",
        });
      } else {
        showError("Airline not found");
        navigate("/airlines");
      }
    } catch (err) {
      showError("Failed to load airline");
      navigate("/airlines");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) {
      return showError("Name is required");
    }

    setLoading(true);
    try {
      if (isEdit) {
        await updateAirline(id, form);
      } else {
        await addAirline(form);
      }
      navigate("/airlines");
    } catch (err) {
      showError(isEdit ? "Failed to update airline" : "Failed to add airline");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title={isEdit ? "Edit Airline" : "Add Airline"}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">
            {isEdit ? "Edit Airline" : "Add New Airline"}
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Name *</label>
              <input
                name="name"
                className="form-control"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">IATA Code</label>
              <input
                name="iata_code"
                className="form-control"
                value={form.iata_code}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Country</label>
              <input
                name="country"
                className="form-control"
                value={form.country}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Alliance</label>
              <input
                name="alliance"
                className="form-control"
                value={form.alliance}
                onChange={handleChange}
              />
            </div>
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn skedq-accent-btn"
                disabled={loading}
              >
                {loading ? "Saving..." : isEdit ? "Update" : "Add"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate("/airlines")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}
